module.exports = __webpack_public_path__ + "img/thermometer.229023d4.png";